import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import { confirmAlert } from "react-confirm-alert";
import { converDateIntoLocalwithmonth } from "Constants";
import EditbillingdetailsModal from "./edit-billing-details";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class BillingDetailsSubheader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            isOpen: false,
        };
    }

    componentDidMount() {

    }
    openModal = (section) => {
        this.setState({
            isOpen: true,
        });
    };
    closeModal = () => {
        this.setState({ isOpen: false });
    };

    mauInfo = () => {

        confirmAlert({
            title: 'Monthly Active Users(MAU)',
            message: 'MAU tracks the number of unique users who visit the platform each month',
            buttons: [

                {
                    label: "OK",
                    onClick: () => {
                    },
                },
            ],
        });

    };


    //Arrow function for renderLoader

    render() {
        let { clientdataforbilling, total_accountusageCount } = this.props;
        // console.log('total_accountusageCount',total_accountusageCount)
        let name = '';
        let email = '';
        let companyname = '';
        let accountactivesince = '';
        let validupto = '';
        let address = '';
        let zipcode = '';
        let state = '';
        let city = '';
        let userlimit = '';
        let userlimitcount = 0;
        let vat_number = 0;
        let plantype = 'No plan';


        if (clientdataforbilling && clientdataforbilling.length > 0) {
            name = `${clientdataforbilling[0].firstname}  ${clientdataforbilling[0].lastname}`;
            email = clientdataforbilling[0].email;
            companyname = clientdataforbilling[0].companyname ? _.startCase(clientdataforbilling[0].companyname): '';
            address = _.startCase(clientdataforbilling[0].address);
            zipcode = _.startCase(clientdataforbilling[0].zipcode);
            state = _.startCase(clientdataforbilling[0].state);
            city = _.startCase(clientdataforbilling[0].city);
            vat_number = _.startCase(clientdataforbilling[0].vat_number);
            userlimit = clientdataforbilling[0].userlimit;
            plantype = clientdataforbilling[0].plantype;
            accountactivesince = converDateIntoLocalwithmonth(clientdataforbilling[0].validityfrom).format("D MMM YYYY");
            validupto = converDateIntoLocalwithmonth(clientdataforbilling[0].validupto).format("D MMM YYYY");
        }
        if (total_accountusageCount ) {
            userlimitcount = userlimit - total_accountusageCount.count

        }

        return (
            <div className="billingdetails-subheader">
                <ul
                    className="nav nav-pills dashboardNavPill"
                >
                    <li
                        onClick={() => this.openModal()}
                        className="dashboardtop-box-"
                        style={{
                            width: '44%',
                            marginLeft: "10px",
                            cursor: "default",
                            height: "210px",
                            cursor: 'pointer',
                            padding: '5px 10px'
                        }}
                    >
                        <div className="" style={{ paddingTop: '15px' }}>
                            <span className="pull-left txtLeft txtLeftSupport">
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_box1_name}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {name}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_box1_email}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {email}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_box1_company}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {companyname}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_box1_vatnumber}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {vat_number}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                       {LocaleStrings.accountsetting_billingdetails_subheader_box1_plantype}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2"> 
                                        {plantype == 'trial' ? 'Trial' : plantype == 'myhub' ? 'MyHub' : plantype == 'whitelabel' ? 'White Label' : plantype == 'multiplewhitelabel' ? 'White Label Multiple' :plantype == 'myhubgroup' ? "My Hub Group":'No Plan Added'}
                                    </div>
                                </div>
                            </span>
                        </div>
                        <span className="pull-right " onClick={() => this.openModal()}>  <img style={{ padding: 0, backgroundColor: '#fff', border: 'none' }} src="../../style/images/custom-icons/edit.svg" /></span>
                    </li>
                    <li
                        className="dashboardtop-box"
                        style={{
                            width: '25%',
                            marginLeft: "10px",
                            cursor: "default",
                            height: "210px",
                            padding: '5px 10px'
                            // cursor: 'pointer'
                        }}
                    >
                        <div className="">
                            <span className="txtLeft txtLeftSupport">
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_total_user_limit}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {userlimit}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_total_used}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {total_accountusageCount.count}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <p className="custom-text1-primary-medium">
                                        {LocaleStrings.accountsetting_billingdetails_subheader_available_limit}
                                    </p>
                                    <div className="custom-text1-primary-medium ml-2">
                                        {userlimitcount}
                                    </div>
                                </div>
                            </span>
                        </div>
                        {/* <span className="pull-right cursor-pointer" onClick={() => this.mauInfo()}>  <img style={{ padding: 0, backgroundColor: '#fff', border: 'none',marginRight:'10px' }} src="style/images/header-icons/infoicon.png" /></span> */}
                        <div style={{fontSize:'12px' }}>{LocaleStrings.accountsetting_billingdetails_subheader_mau_details}</div>
                    </li>
                    <li
                        className="dashboardtop-box-"
                        style={{
                            width: '25%',
                            marginLeft: "10px",
                            cursor: "default",
                            height: "210px",
                        }}
                    >
                        <div className="tabDiv" style={{ paddingLeft: '10px' }}>
                            <span className="txtLeft txtLeftSupport">
                                <p className="smallTxt">
                                    {LocaleStrings.accountsetting_billingdetails_subheader_active_since} {accountactivesince}
                                </p>
                                <p className="smallTxt">
                                    {LocaleStrings.accountsetting_billingdetails_subheader_validtill} {validupto}
                                </p>
                            </span>
                        </div>
                    </li>
                </ul>
                {this.state.isOpen ? (
                    <EditbillingdetailsModal
                        isOpen={this.state.isOpen}
                        onClose={this.closeModal}
                    />
                ) : (
                    ""
                )}
            </div>
        );
    }
}


function mapStateToProps(state) {
    var { session, user } = state;
    return {
        session,
        user,
        deviceSize: state.deviceSize,
        clientdataforbilling: state.clientdataforbilling,
        total_accountusageCount: state.total_accountusageCount
    };
}

export default connect(mapStateToProps, {})(BillingDetailsSubheader);
